module.exports = __webpack_public_path__ + "assets/img/prereg_small.eaa800cd.webp";